import React from 'react'
import { connect } from 'formik'
import { Grid, Typography, useClientOptions } from '@paintscout/ui'
import { getObjectLabels } from '@paintscout/util/builder'
import type {
  PresentationSectionFormProps,
  FormikPresentationSectionConnectProps,
  FormikPresentationSectionValues
} from '../../'

const AboutEstimatorForm = ({ ..._props }: PresentationSectionFormProps & FormikPresentationSectionConnectProps) => {
  const { options } = useClientOptions()
  const objectLabels = getObjectLabels({ options })

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant={'body1'}>
          This section will show information about the {objectLabels.quote.plural} Estimator.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant={'body1'}>The information displayed can be set in the Estimator's profile.</Typography>
      </Grid>
    </Grid>
  )
}

export default connect<PresentationSectionFormProps, FormikPresentationSectionValues>(AboutEstimatorForm)
